import { OpensearchPaginationCursorSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

const RedoSuppliesOrderSchema_ = z.object({
  _id: z.string(),
  name: z.string(),
  createdAt: z.string(),
  fulfillmentStatus: z.string().nullable(),
  trackingNumbers: z.array(z.string()),
});
export const RedoSuppliesOrderSchema: z.ZodType<RedoSuppliesOrder> =
  RedoSuppliesOrderSchema_;
export interface RedoSuppliesOrder
  extends z.infer<typeof RedoSuppliesOrderSchema_> {}

export const getRedoSuppliesOrders = {
  name: "getRedoSuppliesOrders" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z.number(),
    search: z.string().nullish(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    orders: z.array(RedoSuppliesOrderSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export const getRedoSuppliesOrdersCount = {
  name: "getRedoSuppliesOrdersCount" as const,
  input: z.object({ search: z.string().nullish() }),
  output: z.object({ total: z.number() }),
};
